// Fallbacks are determined in the translations repo
export const fallbacks = {
    default: ["en-US"],
};
//# sourceMappingURL=fallbacks.js.map